export { default as Avatar } from './Avatar';
export { AvatarSize } from './constants';
export type { AvatarProps } from './interfaces';
